<template>
    <div class="hts-auth-forgot-password">
        <div class="hts-auth-forgot-password__container">
            <!--  LEFT -->
            <div class="container-left">
                <div class="container">
                    <div class="title">
                        <img
                            class="logo"
                            :src="logoUrl"
                            alt="Logo"
                            @error="onLogoError" >
                    </div>
                    <div class="title mt-3">
                        <h2 class="text">
                            {{ $t('labels.forgotPassword') }}
                        </h2>
                    </div>
                    <div class="input-container">
                        <div class="mt-6">
                            <hts-form
                                class="space-y-6"
                                @submit="handleSubmitFormForgotPassword">
                                <div class="space-y-6">
                                    <hts-form-radio
                                        v-model="formData.registerBy"
                                        label="Đăng ký bằng"
                                        :items="registerByItems"
                                        value-key="key"
                                        label-key="label" />

                                    <hts-form-input
                                        v-if="formData.registerBy === 'email'"
                                        v-model="formData.email"
                                        name="email"
                                        prop="email"
                                        placeholder="Email"
                                        required>
                                        <template #prefix>
                                            <hi-envelope-icon class="h-6 w-6 ml-2 text-gray-500" />
                                        </template>
                                    </hts-form-input>

                                    <hts-form-phone
                                        v-if="formData.registerBy === 'phone'"
                                        v-model="formData.phone"
                                        :placeholder="$t('labels.phone')"
                                        prop="phone"
                                        name="phone"
                                        required />

                                    <h5
                                        v-if="success"
                                        class="text-success-500">
                                        Yêu cầu đặt lại mật khẩu thành công, vui lòng kiểm tra email/zalo để đổi lại mật khẩu
                                    </h5>

                                    <hts-form-button
                                        :loading="loading"
                                        type="submit"
                                        color="primary"
                                        class="form-button">
                                        <span class="absolute left-0 inset-y-0 flex items-center pl-3" />
                                        <p class="flex items-center justify-center">
                                            Yêu cầu đặt lại mật khẩu
                                            <hi-lock-open-icon class="h-6 w-6 ml-2" />
                                        </p>
                                    </hts-form-button>
                                    <div class="flex gap-2 justify-center items-center mt-2">
                                        <router-link
                                            :to="routes.login"
                                            class="flex font-medium"
                                            color="main">
                                            <hi-arrow-small-left-icon class="h-6 w-6 ml-2" />
                                            {{ $t('labels.login') }}
                                        </router-link>
                                    </div>
                                </div>
                            </hts-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import data from '@/pages/trucker-[id]/company/user-group/-components/imports/data'

const { registerByItems } = data()
const routes = {
  login: {
    name: 'auth-login'
  }
}

definePageMeta({
  layout: 'auth'
})

// const emits = defineEmits()

/* Handle submit */
const initForm = {
  registerBy: 'email',
  email: '',
  phone: {
    countryCode: 'Vietnam +84',
    phone: '',
    code: '+84'
  }
} as { [key: string]: any }

const formData = ref({ ...initForm })

const loading = ref(false)

const success = ref(false)

const resetForm = () => {
  formData.value = { ...initForm }
}

const logoUrl = computed(() => {
  const defaultLogoUrl = '/assets/logo.png'
  return defaultLogoUrl
})

const onLogoError = (event: Event) => {
  const target = event.target as HTMLImageElement
  target.style.display = 'none'
}

const handleSubmitFormForgotPassword = async () => {
  loading.value = true

  const api = {
    url: '/auth/forgot-password',
    method: 'POST'
  }

  const data = await $api(api, { body: formData.value })
  const resData: any = data?.data?.value

  if (resData?.success) {
    resetForm()
    success.value = true
  }

  loading.value = false
}
</script>
